import { gql } from '@apollo/client';

export const FETCH_EMAIL_UPDATE_STATUS = gql`
  query Flex_FetchEmailUpdateStatus($utilityAccountId: Int!) {
    utilityAccount(id: $utilityAccountId) {
      updateAccountSettingsScrapeUuid
    }
  }
`;
